<h3 class="text-center" style="color: #5A1727">Firma de Documentos</h3>
<mat-horizontal-stepper linear #stepper>
  <mat-step [completed]="vehiculoStepCompleted" [editable]="isEditable">
    <ng-template matStepLabel>Vehículo </ng-template>
    <form [formGroup]="datosVehiculos" autocomplete="off" (ngSubmit)="siguiente()">
      <h3 class="text-left" style="color: #5A1727">Datos Vehículos</h3>
      <hr>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Matrícula</mat-label>
        <input matInput matNativeControl type="text" maxlength="10" formControlName="matricula" (input)="getVehiculo()">
      </mat-form-field>
      <div class="input-group">
        <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
          <mat-label>Nº Bastidor (E)</mat-label>
          <input matInput matNativeControl type="text" maxlength="17" [class.is-invalid]="bastidorNoValido"
                formControlName="bastidor" onkeydown="return /[A-HJ-NPR-Za-hj-npr-z\d]/i.test(event.key)">
          <small *ngIf="bastidorNoValido">
            El numero de Bastidor es <strong>requerido</strong>
          </small>
        </mat-form-field>
        <div class="input-group-btn">
          <button mat-button  class="btn btn-secondary" style="vertical-align: middle; margin-top: 6px" (click)="getDatosEITV()" matTooltip="Presione para recuperar los datos del vehículo desde la DGT">
            Recuperar datos técnicos <mat-icon>directions_car</mat-icon>
          </button>
        </div>
      </div>

      <mat-form-field appearance="outline" class="col-lg-5 col-md-6 col-sm-12">
        <mat-label>Clasificación</mat-label>
        <select matInput matNativeControl formControlName="tipoVehiculo">
          <option label="--Seleccionar--"></option>
          <option value="03">03xx – CICLOMOTOR</option>
          <option value="04">04xx – MOTOCICLETA</option>
          <option value="06">06xx – AUTOMÓVIL DE TRES RUEDAS</option>
          <option value="10">10xx – TURISMO</option>
          <option value="17">17xx – PICK UP</option>
          <option value="20">20xx – CAMIÓN MMA ≤3.500 kg</option>
          <option value="21">21xx – CAMIÓN 3.500 kg. < MMA ≤ 12.500 kg</option>
          <option value="22">22xx – CAMIÓN MMA > 12.000 kg</option>
          <option value="24">24xx – FURGÓN/FURGONETA MMA ≤ 3.500 kg</option>
          <option value="31">31xx – VEHICULO MIXTO ADAPTABLE</option>
          <option value="32">32xx – AUTO-CARAVANA MMA ≤ 3.500 kg</option>
          <option value="33">33xx – AUTO-CARAVANA MMA > 3.500 kg</option>
          <option value="66">66xx – QUAD ATV</option>
        </select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Marca</mat-label>
        <input matInput matNativeControl type="text" maxlength="45" formControlName="marca"
               placeholder="Marca">
      </mat-form-field>

      <mat-form-field appearance="outline" class="col-lg-3 col-md-6 col-sm-12">
        <mat-label>Modelo</mat-label>
        <input matInput matNativeControl type="text" maxlength="50" formControlName="modelo"
               placeholder="Modelo">
      </mat-form-field>

      <div class="text-center mt-5">
        <button mat-button type="submit" class="btn-secondary">Siguiente</button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="(datosCliente | async)" [editable]="isEditable">
    <ng-template matStepLabel>Cliente</ng-template>
    <app-cliente #clienteComprador (datoCliente)="siguiente2($event)"></app-cliente>
  </mat-step>

  <mat-step [editable]="isEditable">
    <ng-template matStepLabel>Resumen</ng-template>
    <h3 class="text-left" style="color: #5A1727">Resumen de datos</h3>
    <hr>
    <div class="row" *ngIf="DatoCliente">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <p><strong>Documentos:</strong> {{ DatoCliente.documentos }}</p>
        <p><strong>Trámite relacionado:</strong> {{ DatoCliente.tipoTramite }}</p>
        <p><strong>Matrícula:</strong> {{ DatoCliente.matricula }}</p>
        <p><strong>Bastidor:</strong> {{ DatoCliente.bastidor }}</p>
        <p><strong>Marca:</strong> {{ DatoCliente.marca }}</p>
        <p><strong>Modelo:</strong> {{ DatoCliente.modelo }}</p>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <p><strong>Cliente:</strong> {{ DatoCliente.nombre }} {{ DatoCliente.apellido1 }}</p>
        <p><strong>NIF:</strong> {{ DatoCliente.nif }}</p>
        <p><strong>Email:</strong> {{ DatoCliente.email }}</p>
        <p><strong>Teléfono:</strong> {{ DatoCliente.telefono }}</p>
        <p><strong>Colaborador:</strong> {{ DatoCliente.colaborador }}</p>
      </div>
    </div>
    <div class="text-center mt-5">
      <button mat-button class="btn-secondary" matStepperPrevious>Anterior</button>
      <button mat-button class="aceptar ml-3" (click)="guardar()" [disabled]="!DatoCliente">Guardar</button>
    </div>
  </mat-step>

</mat-horizontal-stepper>
<div *ngIf="spinnerEITV" class="spinner swal2-container swal2-center swal2-backdrop-show">
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png">
  <h4 style="margin-top: 200px; color: white">Conectando con la DGT...</h4>
</div>
<div *ngIf="spinnerGuardar" class="spinner swal2-container swal2-center swal2-backdrop-show">
  <img class="spinner-img" alt="" src="../../../assets/img/logo-empresa.png">
  <h4 style="margin-top: 200px; color: white">Guardando...</h4>
</div>
